import React from 'react'
import MessageUI from './MessageUI'
import './Progress.css'

const ProgressUI = ({messageList, labelKey, percent, alarm}) =>
  <div className={`w_progress ${alarm?'alarm':''}`}>
    <div className='g_muted g_small'>
      <MessageUI messageList={messageList} messageKey={labelKey} />
    </div>
    <div className='g_flex_h hor'>
      <div className='bar'>
        <div className='foo' style={{width: percent + '%'}} />
      </div>
      <div className='g_m_left_50 g_muted'>{percent}%</div>
    </div>
  </div>

export default ProgressUI
